import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { AbsenceReportApiResponse } from '../../../api/AbsenceReportApi';
import { useContainer } from '../../useContainer';

type QuarterlyTrendData = AbsenceReportApiResponse.GetQuarterlyTrend['body'];

const EMPTY_DATA: QuarterlyTrendData = {
    scope: { type: 'ORGANIZATION' },
    quarters: [],
};

export interface IGetQuarterlyTrendQuery {
    year: number;
    projectId?: string;
    enabled?: boolean;
}

const useHttpGetQuarterlyTrend = (query: IGetQuarterlyTrendQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<QuarterlyTrendData>(EMPTY_DATA);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (query.enabled === false) return;

        setIsReady(false);
        setIsError(false);
        const { exec, abort } = absenceReportApi.getQuarterlyTrend({
            query: { year: query.year, projectId: query.projectId },
            onSuccess: res => {
                setData(res.body);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.year, query.projectId, query.enabled]);

    return { data, isReady, isError };
};

export default useHttpGetQuarterlyTrend;
